import { useTEAME223SpeculativeAvatarData } from './useTEAME223SpeculativeAvatarData';

// Only mount this component when the TEAME-223 flag is enabled.
// Relay hooks inside useTEAME223SpeculativeAvatarData only run when this component is rendered.
export function SkillResourceAvatarPanel() {
  const { avatarDataUrl } = useTEAME223SpeculativeAvatarData();
  if (!avatarDataUrl) return null;
  return (
    <div className="tw-mb-4 tw-flex tw-flex-col tw-items-center tw-bg-white tw-rounded-lg tw-border tw-border-blue-200 tw-p-4">
      <img
        src={avatarDataUrl}
        alt="Your future self avatar"
        className="tw-h-48 tw-w-48 tw-rounded-lg tw-border-2 tw-border-blue-300 tw-object-cover"
      />
    </div>
  );
}
